import { render, staticRenderFns } from "./LatestListComponent.vue?vue&type=template&id=56c40bd2&scoped=true&"
import script from "./LatestListComponent.vue?vue&type=script&lang=js&"
export * from "./LatestListComponent.vue?vue&type=script&lang=js&"
import style0 from "./LatestListComponent.vue?vue&type=style&index=0&id=56c40bd2&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56c40bd2",
  null
  
)

export default component.exports